@use 'styles/colors' as *;
@use 'styles/mixins/ellipsis' as *;
@use 'styles/mixins/fonts' as *;

.largeSemiboldText {
    @include ellipsis;
    @include largeSemiboldFont;
}
